import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { COLOR, LINEAR_COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledLinearStatus = styled(Typography)`
  background: ${({ color, progress, toright }) =>
    `linear-gradient(to ${toright ? 'right' : 'left'}, ${
      toright ? LINEAR_COLOR[color].linear : LINEAR_COLOR[color].background
    } ${progress}%, ${
      toright ? LINEAR_COLOR[color].background : LINEAR_COLOR[color].linear
    } ${100 - progress}%)`};
  color: ${({ color }) => LINEAR_COLOR[color].text};
  border-radius: 17px;
  font-size: 13px;
  font-weight: 500;
  width: 80px;
  padding: 1px 10px;
  text-align: center;
  white-space: nowrap;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
`;

export const StyledChip = styled(Typography)`
  background-color: ${({ color }) => TRANSPARENT_COLOR[color]};
  color: ${({ color }) => COLOR[color]};
  padding: 1px 10px;
  border-radius: 17px;
  font-size: 14px;
  font-weight: 500;
  width: 80px;
  margin-right: 12px;
  text-align: center;
  white-space: nowrap;
`;
